import { Injectable, signal, computed, inject } from '@angular/core';
import { PlatformService } from './platform.service';

@Injectable({
  providedIn: 'root'
})
export class ProgrammingModeService {
  private platform = inject(PlatformService);
  
  // Signal state for programming mode
  private _isProgrammingMode = signal(false);
  
  // Read-only computed signal
  public readonly isProgrammingMode = computed(() => this._isProgrammingMode());
  
  // Keyboard event handler
  private keydownHandler = (event: KeyboardEvent) => {
/*     console.log('🔍 Keyboard event detected:', {
      key: event.key,
      ctrl: event.ctrlKey,
      shift: event.shiftKey,
      alt: event.altKey,
      keyCode: event.keyCode,
      code: event.code
    }); */
    
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'x') {
      console.log('🎯 Programming mode shortcut detected!');
      event.preventDefault();
      this.toggleProgrammingMode();
    }
  };

  constructor() {
    console.log('🚀 ProgrammingModeService initialized');
    
    // Only add keyboard listener in browser environment
    if (this.platform.isBrowser) {
      this.addKeyboardListener();
      console.log('⌨️ Keyboard listener added (browser environment)');
    } else {
      console.log('🚫 Skipping keyboard listener (SSR environment)');
    }
  }

  private addKeyboardListener(): void {
    console.log('📝 Adding keyboard event listener to document');
    this.platform.addDocumentListener('keydown', this.keydownHandler, { capture: true });
  }

  private removeKeyboardListener(): void {
    console.log('🗑️ Removing keyboard event listener from document');
    this.platform.removeDocumentListener('keydown', this.keydownHandler, { capture: true });
  }

  public toggleProgrammingMode(): void {
    const newState = !this._isProgrammingMode();
    this._isProgrammingMode.set(newState);
    console.log(`🧪 Programming mode ${newState ? 'ACTIVATED' : 'DEACTIVATED'}`);
    console.log('📊 Current programming mode state:', this._isProgrammingMode());
  }

  public enableProgrammingMode(): void {
    this._isProgrammingMode.set(true);
    console.log('✅ Programming mode ENABLED');
  }

  public disableProgrammingMode(): void {
    this._isProgrammingMode.set(false);
    console.log('❌ Programming mode DISABLED');
  }

  // Cleanup method for when service is destroyed
  public destroy(): void {
    if (this.platform.isBrowser) {
      this.removeKeyboardListener();
    }
  }
}
